export const delay_levels = [
    {
        value: -1,
        title: 'Adv',
        background: '#81C784',
        color: 'black'
    },
    // {
    //     value: 0,
    //     title: ''
    // },
    {
        value: 1,
        title: 'Delay',
        background: '#FFF59D',
        color: 'black'
    },
    {
        value: 2,
        title: 'Delay',
        background: '#EF6C00',
        color: 'white'
    },
    {
        value: 3,
        title: 'Delay',
        background: '#BF360C',
        color: 'white'
    },
]


export const delay_levels_hash = delay_levels.reduce((t, i) => {
    t[i.value] = i
    return t
}, {})